import withPaidChannelAttributes from "HoC/withPaidChannelAttributes";
import TimeAndDayInsights from "features/analytics/components/TimeAndDayInsights";

function AdTimeAndDayInsightsPage({ paidChannelAttributes }) {
  return <TimeAndDayInsights attributes={paidChannelAttributes} />;
}

export default withPaidChannelAttributes(AdTimeAndDayInsightsPage);
